import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalService } from "ngx-bootstrap/modal";
import { ModalConfirmarViajeComponent } from "../modal-confirmar-viaje/modal-confirmar-viaje.component";
import { ModalCancelarViajeComponent } from "../modal-cancelar-viaje/modal-cancelar-viaje.component";
import { ViajeDTO } from "../../../dtos/viaje.dto";
import { ParadaDTO } from "../../../dtos/parada.dto";
import { MovilDTO } from "../../../dtos/movil.dto";
import { ConductorDTO } from "../../../dtos/conductor.dto";
import { ApiService } from "../../services/api.service";
import { MovilService } from "../../services/movil.service";
import { ConductorService } from "../../services/conductor.service";
import { EventService } from "../../services/event.service";
import { FormsModule } from '@angular/forms';
import { Subject, Subscription, debounceTime, distinctUntilChanged, finalize } from 'rxjs';
import moment from 'moment';
import { ViajeService } from '../../services/viaje.service';
import { GetParadasViajeResponseDTO } from '../../../dtos/response/getParadasViaje.response.dto';
import { HttpErrorResponse } from '@angular/common/http';
import { AppMessage } from '../../app.message';
import { GeneralResponseDTO } from '../../../dtos/response/general.response.dto';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { GetListaMovilesResponseDTO } from '../../../dtos/response/getListaBuses.response.dto';
import { GetListaConductoresResponseDTO } from '../../../dtos/response/getListaConductores.response.dto';
import { PdfDTO } from '../../../dtos/pdf.dto';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-viaje',
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule, NgSelectModule],
  templateUrl: './viaje.component.html',
  styleUrl: './viaje.component.scss'
})
export class ViajeComponent implements OnInit, OnDestroy {

  @Output() viewChange = new EventEmitter<{ type: string, viajeSeleccionado: ViajeDTO | null }>();

  viajeSeleccionado: ViajeDTO;

  paradas: ParadaDTO[] = [];
  fechaPrimeraParada: string;
  // CON-1004: inicio editado en vivo (fecha+hora completa) y base original para desplazar paraderos
  inicioEditado: any;
  paradasOriginales: string[] = [];
  loading: boolean = false;
  nuevaHoraInicio: string = '';
  guardandoHora: boolean = false;
  procesandoPdf: boolean = false;

  listaMoviles: MovilDTO[];
  movilSeleccionado: MovilDTO;
  asignandoMovil: boolean = false;
  quitandoMovil: boolean = false;

  listaConductores: ConductorDTO[];
  conductorSeleccionado: ConductorDTO;
  asignandoConductor: boolean = false;
  quitandoConductor: boolean = false;

  tipoBusqueda = 'RAPIDA';

  // Propiedad para mostrar el botón "Confirmar & Imprimir" solo en dev y qa
  mostrarBotonConfirmarImprimir = true;

  // Bus search
  busSearchText: string = '';
  busSearchResults: MovilDTO[] = [];
  busLoading: boolean = false;
  selectedBus: MovilDTO | null = null;
  showBusResults: boolean = false;
  private busSearchSubject = new Subject<string>();

  // Conductor search
  conductorSearchText: string = '';
  conductorSearchResults: ConductorDTO[] = [];
  conductorLoading: boolean = false;
  selectedConductor: ConductorDTO | null = null;
  showConductorResults: boolean = false;
  private conductorSearchSubject = new Subject<string>();

  // Assignment tracking

  subscriberViajeSeleccionado: Subscription;
  private viajeConfirmadoSubscription: Subscription;
  private crearViajeSubscription: Subscription;
  private viajeActualizadoMqttSubscription: Subscription;
  private movilCambiadoDeSucursalSubscription: Subscription;

  /*
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['viajeSeleccionado'] && changes['viajeSeleccionado'].currentValue) {
      // Force reference change to trigger change detection
      this.viajeSeleccionado = { ...changes['viajeSeleccionado'].currentValue };

      // Load trip stops when the selected trip changes
      //this.cargarParadas();

      // Set initial values for bus and conductor if they exist
      if (this.viajeSeleccionado.movil) {
        this.selectedBus = this.viajeSeleccionado.movil;
        this.busSearchText = this.viajeSeleccionado.movil.numeroInterno || '';
        this.busAsignado = true;
      } else {
        this.selectedBus = null;
        this.busSearchText = '';
        this.busAsignado = false;
      }

      if (this.viajeSeleccionado.conductor) {
        this.selectedConductor = this.viajeSeleccionado.conductor;
        this.conductorSearchText = this.viajeSeleccionado.conductor.visibleId || '';
        this.conductorAsignado = true;
      } else {
        this.selectedConductor = null;
        this.conductorSearchText = '';
        this.conductorAsignado = false;
      }
    }
  }
  */

  constructor(
    private modalService: BsModalService,
    private apiService: ApiService,
    private movilService: MovilService,
    private conductorService: ConductorService,
    private eventService: EventService,
    private viajeService: ViajeService,
    private toastr: ToastrService,
    private userService: UserService
  ) {

  }

  ngOnInit(): void {
    console.log('[ngOnInit] ejecutado');
    this.subscriberViajeSeleccionado = this.viajeService.viajeSeleccionadoDespachador$
      .pipe(distinctUntilChanged((a, b) => a?.uuid === b?.uuid))
      .subscribe(viaje => {

        this.movilSeleccionado = null;
        this.conductorSeleccionado = null;

        this.viajeSeleccionado = viaje;
        if (this.viajeSeleccionado) {
          this.cargarParadas();
        }
      });

    this.viajeActualizadoMqttSubscription = this.eventService.subscribe('VIAJE_ACTUALIZADO_MQTT_EVENT', (viaje) => {
      // Solo actualizar si es el mismo viaje que está actualmente seleccionado
      if (this.viajeSeleccionado && viaje && this.viajeSeleccionado.uuid === viaje.uuid) {
        const horaAnterior = this.viajeSeleccionado.fechahoraInicio;
        this.viajeSeleccionado = viaje;
        if (horaAnterior != viaje.fechahoraInicio) {
          this.cargarParadas();
        }
      }
    })

    this.viajeConfirmadoSubscription = this.eventService.subscribe('VIAJE_CONFIRMADO_EVENT', (data: { viaje: ViajeDTO, imprimir: boolean }) => {

      // Update the local viajeSeleccionado if it's the same viaje
      if (this.viajeSeleccionado && data.viaje && this.viajeSeleccionado.uuid === data.viaje.uuid) {
        this.viajeSeleccionado = { ...this.viajeSeleccionado, ...data.viaje, confirmado: true };
      }

      /* Esto hacía que se imprimiera 2 veces
      if (!data.imprimir) {
        return;
      }
      this.getRutaViajePDF();
      */
    });

    this.movilCambiadoDeSucursalSubscription = this.eventService.subscribe('MOVIL_CAMBIADO_SUCURSAL_EVENT', () => {
      this.cargarParadas();
    });

    this.crearViajeSubscription = this.eventService.subscribe('CREAR_VIAJE_EVENT', () => {
      console.log("CREAR_VIAJE_EVENT en viajes");
    });
  }

  getConductorSugerido(){
    if(!this.viajeSeleccionado.conductorSugerido){
      return '--';
    }
    const conductor = this.viajeSeleccionado.conductorSugerido;
    return conductor.visibleId + ' ' + conductor.nombres + ' ' + conductor.apellidoPaterno + ' ' + conductor.contratoSucursal.nombre;
  }


  getInfoMovil(movil: MovilDTO) {
    if (!movil || !movil.tipoMovil || !movil.tipoMovil.combustible) {
      return '--';
    }

    if (movil.tipoMovil.combustible === 'DIESEL') {
      if (movil.nivelCombustible == null) {
        return `${movil.numeroInterno}, ${movil.patente}, ${movil.estado}, ${movil.tipoMovil.codigo}, Diesel / --%`;
      }
      return `${movil.numeroInterno}, ${movil.patente}, ${movil.estado}, ${movil.tipoMovil.codigo}, Diesel: ${movil.nivelCombustible}%`;
    }

    if (movil.tipoMovil.combustible === 'ELECTRICO') {
      if (movil.estadoCarga == null) {
        return `${movil.numeroInterno}, ${movil.patente}, ${movil.estado}, ${movil.tipoMovil.codigo}, Electrico / --%`;
      }
      return `${movil.numeroInterno}, ${movil.patente}, ${movil.estado}, ${movil.tipoMovil.codigo}, Electrico: ${movil.estadoCarga}%`;
    }

    return `${movil.numeroInterno}, ${movil.patente}, ${movil.estado}, ${movil.tipoMovil.codigo}`;
  }


  getIdVisibleConductorSugerido(){
    if(!this.viajeSeleccionado.conductorSugerido){
      return '0'
    }
    const conductor = this.viajeSeleccionado.conductorSugerido;
    return conductor.visibleId;
  }

  ngOnDestroy(): void {
    if (this.viajeConfirmadoSubscription) {
      this.viajeConfirmadoSubscription.unsubscribe();
    }
    if (this.crearViajeSubscription) {
      this.crearViajeSubscription.unsubscribe();
    }
    if (this.subscriberViajeSeleccionado) {
      this.subscriberViajeSeleccionado.unsubscribe();
    }
    if (this.viajeActualizadoMqttSubscription) {
      this.viajeActualizadoMqttSubscription.unsubscribe();
    }
    if(this.movilCambiadoDeSucursalSubscription){
      this.movilCambiadoDeSucursalSubscription.unsubscribe();
    }
  }

  buscarMovil(term: string, item: any): boolean {
    term = term.toLowerCase();
    return (
      item.numeroInterno?.toLowerCase().includes(term) ||
      item.patente?.toLowerCase().includes(term) ||
      item.estado?.toLowerCase().includes(term) ||
      item.tipoMovil?.codigo?.toLowerCase().includes(term)
    );
  }


  buscarConductor(term: string, item: any): boolean {
    term = term.toLowerCase();
    return (
      item.visibleId?.toLowerCase().includes(term) ||
      item.nombres?.toLowerCase().includes(term) ||
      item.apellidoPaterno?.toLowerCase().includes(term) ||
      item.estado?.toLowerCase().includes(term)
    );
  }

  cargarParadas(): void {
    if (this.viajeSeleccionado) {
      this.loading = true;
      this.apiService.getParadasViaje(this.viajeSeleccionado.uuid).subscribe(
        (resp) => this.getParadasSuccess(resp),
        (error) => this.getParadasError(error)
      );
    }
  }

  getParadasSuccess(getParadasViajeResponseDTO: GetParadasViajeResponseDTO) {
    this.paradas = getParadasViajeResponseDTO.data;
    // CON-1004: base original (para desplazar paraderos en vivo) y estado del inicio editado
    this.paradasOriginales = this.paradas.map(p => p.fechahoraPlanificada);
    this.inicioEditado = this.paradas[0] ? moment.utc(this.paradas[0].fechahoraPlanificada).local() : null;
    this.fechaPrimeraParada = this.formateaHora(this.paradas[0]?.fechahoraPlanificada)
    this.loading = false;
    this.getListaMoviles();
    this.getListaConductores();
  }

  getParadasError(error: HttpErrorResponse) {
    console.log('error listar paradas', error);
    this.loading = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PARADS_DESPACHADOR_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  formatearTiempo(event: any) {
    const input = event.target;
    let value = input.value;
    const isBackspace = event.inputType === 'deleteContentBackward';

    // Remover todo excepto números
    value = value.replace(/[^0-9]/g, '');

    // Limitar a 4 dígitos
    if (value.length > 4) {
      value = value.slice(0, 4);
    }

    // Agregar ":" después del segundo dígito
    if (value.length >= 3) {
      value = value.slice(0, 2) + ':' + value.slice(2);
    } else if (value.length >= 2 && !isBackspace) {
      // Solo agregar ":" si no estamos borrando hacia atrás
      value = value.slice(0, 2) + ':';
    }

    input.value = value;

    // Mover cursor después del ":" si recién lo insertamos
    if (!isBackspace && value.length === 3 && value.includes(':')) {
      input.setSelectionRange(3, 3);
    }
    this.fechaPrimeraParada;
  }

  normalizarCampoHora() {
    let value = this.fechaPrimeraParada.replace(/[^0-9]/g, '');

    if (value.length === 1) {
      // "1" => "01:00"
      this.fechaPrimeraParada = `0${value}:00`;
    } else if (value.length === 2) {
      // "11" => "11:00"
      this.fechaPrimeraParada = `${value}:00`;
    } else if (value.length === 3) {
      // "111" => "11:10"
      this.fechaPrimeraParada = `${value.slice(0, 2)}:${value.slice(2)}0`;
    } else if (value.length === 4) {
      // "1130" => "11:30"
      this.fechaPrimeraParada = `${value.slice(0, 2)}:${value.slice(2)}`;
    } else {
      this.fechaPrimeraParada = '00:00';
    }

    // CON-1004: tras normalizar la hora tipeada, resolver el día y desplazar paraderos en vivo
    this.aplicarHoraTipeada();
  }

  // CON-1004: resuelve una hora tipeada (HH:mm) a una fecha+hora completa. Se ancla al día ACTUAL
  // del editor (respeta el día que se haya alcanzado con los +/-), aplicando ±12h para el cruce de
  // medianoche relativo a ese día. Luego desplaza los paraderos en vivo.
  aplicarHoraTipeada() {
    if (!this.paradasOriginales.length || !this.inicioEditado) return;
    const [horas, minutos] = this.fechaPrimeraParada.split(':').map(Number);
    if (isNaN(horas) || isNaN(minutos)) return;

    const base = this.inicioEditado.clone();
    const nueva = base.clone().set({ hour: horas, minute: minutos, second: 0, millisecond: 0 });
    const diffMinutos = nueva.diff(base, 'minutes');
    if (diffMinutos > 12 * 60) {
      nueva.subtract(1, 'day');
    } else if (diffMinutos < -12 * 60) {
      nueva.add(1, 'day');
    }

    this.inicioEditado = nueva;
    this.aplicarDesplazamientoParaderos();
  }

  formateaHora(fechaHoraPlanificada: string) {
    const date = moment.utc(fechaHoraPlanificada).local();
    const horas = date.format('HH');
    const minutos = date.format('mm');
    return `${horas}:${minutos}`;
  }

  ajustarHora(baseUtc: string, hhmm: string): string {
    const [h, m] = hhmm.split(':').map(Number);
    const fechaLocal = moment.utc(baseUtc).local();
    fechaLocal.add(h, 'hours').add(m, 'minutes');
    return fechaLocal.format('YYYY-MM-DDTHH:mm:ss');
  }

  calculateDuration(startDate: string, endDate: string): string {
    try {
      const start = moment(startDate);
      const end = moment(endDate);

      if (!start.isValid() || !end.isValid()) {
        return '--';
      }

      const duration = moment.duration(end.diff(start));
      const totalMinutes = duration.asMinutes();

      // Handle negative durations
      if (totalMinutes < 0) {
        const absDuration = moment.duration(Math.abs(totalMinutes), 'minutes');
        const hours = Math.floor(absDuration.asHours());
        const minutes = absDuration.minutes();

        if (hours === 0) {
          return `-${minutes}m`;
        } else {
          return `-${hours}h ${minutes}m`;
        }
      }

      // Handle positive durations
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();

      if (hours === 0) {
        return `${minutes}m`;
      } else {
        return `${hours}h ${minutes}m`;
      }
    } catch (error) {
      console.error('Error calculating duration:', error);
      return '--';
    }
  }

  tienePermisoConfirmarViaje(): boolean {
    return this.userService.tienePermiso('VIAJE_CONFIRMAR');
  }

  tienePermisoEditarInicioViaje(): boolean {
    return this.userService.tienePermiso('VIAJE_EDITAR_INICIO');
  }

  tienePermisoAsignarMovil(): boolean {
    return this.userService.tienePermiso('VIAJE_CAMBIAR_MOVIL');
  }

  tienePermisoAsignarConductor(): boolean {
    return this.userService.tienePermiso('VIAJE_CAMBIAR_CONDUCTOR');
  }

  tienePermisoQuitarMovil(): boolean {
    return this.userService.tienePermiso('VIAJE_QUITAR_MOVIL');
  }

  tienePermisoQuitarConductor(): boolean {
    return this.userService.tienePermiso('VIAJE_QUITAR_CONDUCTOR');
  }

  tienePermisoImprimirVoucherRuta(): boolean {
    return this.userService.tienePermiso('VOUCHER_RUTA_VIAJE');
  }

  tienePermisoCancelarViaje(): boolean {
    return this.userService.tienePermiso('VIAJE_CANCELAR');
  }

  confirmar() {
    if (this.viajeSeleccionado) {
      this.modalService.show(ModalConfirmarViajeComponent, {
        ignoreBackdropClick: false,
        keyboard: true,
        class: 'modal-dialog-centered modal-xs',
        initialState: {
          viaje: this.viajeSeleccionado
        }
      });
    }
  }

  confirmarEImprimir() {
    if (this.edicionBloqueada()) {
      return;
    }
    if (this.viajeSeleccionado) {
      this.procesandoPdf = true;
      this.viajeService.confirmarConductorMovil(
        this.viajeSeleccionado.uuid,
        this.viajeSeleccionado.conductor.uuid,
        this.viajeSeleccionado.movil.uuid
      ).subscribe({
        next: (response) => {
          if (response.success) {
            console.log('Viaje confirmado exitosamente');

            // Update the confirmado property
            this.viajeSeleccionado.confirmado = true;

            // Store the selected viaje in the service
            this.viajeService.setViajeSeleccionado(this.viajeSeleccionado);

            // Publish event to notify that a viaje has been confirmed
            this.eventService.publish('VIAJE_CONFIRMADO_EVENT', { viaje: this.viajeSeleccionado, imprimir: true });

            // Call PDF print service
            this.getRutaViajePDF();

          } else {
            console.error('Error al confirmar viaje:', response.msg);
            this.procesandoPdf = false;
            this.toastr.warning(response.msg, 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
          }
        },
        error: (error) => {
          console.error('Error al confirmar viaje:', error);
          this.procesandoPdf = false;
          const msg = error.error && error.error.msg ? error.error.msg : 'Error al confirmar el viaje';
          this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      });
    }
  }

  confirmarEImprimirEIniciar() {

    if (!this.viajeSeleccionado) {
      this.toastr.warning("No hay viaje seleccionado", 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    if (this.edicionBloqueada()) {
      return;
    }

    if (this.edicionBloqueada()) {
      return;
    }

    const viajeUuid = this.viajeSeleccionado.uuid;
    const conductorUuid = this.viajeSeleccionado.conductor.uuid;
    const movilUuid = this.viajeSeleccionado.movil.uuid;

    this.apiService.confirmarConductorMovil(viajeUuid, conductorUuid, movilUuid)
      .subscribe({
        next: (response) => {

          if (response.success) {
            this.viajeSeleccionado.confirmado = true;
            this.viajeService.setViajeSeleccionado(this.viajeSeleccionado);
            this.eventService.publish('VIAJE_CONFIRMADO_EVENT', { viaje: this.viajeSeleccionado, imprimir: true });

            this.apiService.getRutaViajePDF(viajeUuid)
              .subscribe({
                next: (response) => {
                  this.apiService.iniciarViaje(viajeUuid, 50)
                    .subscribe({
                      next: (response) => {
                        if (response.success) {
                          this.eventService.publish('VIAJE_INICIADO_EVENT', this.viajeSeleccionado);
                        } else {
                          console.error('Error al iniciar viaje:', response.msg);
                          this.toastr.warning(response.msg, 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
                        }
                      },
                      error: (error) => {
                        console.error('Error al iniciar viaje:', error);
                        const msg = error.error && error.error.msg ? error.error.msg : 'Error al iniciar el viaje';
                        this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
                      }
                    })
                  this.getRutaViajePDFSuccess(response)

                },
                error: (error) => {
                  this.getRutaViajePDFError(error)
                }
              });

          } else {
            console.error('Error al confirmar viaje:', response.msg);
            this.toastr.warning(response.msg, 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
          }
        },
        error: (error) => {
          console.error('Error al confirmar viaje:', error);
          const msg = error.error && error.error.msg ? error.error.msg : 'Error al confirmar el viaje';
          this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      });

  }

  verBuses() {
    if (this.viajeSeleccionado) {
      this.viewChange.emit({ type: 'bus', viajeSeleccionado: this.viajeSeleccionado });
    }
  }

  verConductores() {
    if (this.viajeSeleccionado) {
      this.viewChange.emit({ type: 'conductor', viajeSeleccionado: this.viajeSeleccionado });
    }
  }

  cancelar() {
    // CON-1004: no permitir cancelar si el viaje está NO_INICIADO o FINALIZADO
    if (this.edicionBloqueada()) {
      return;
    }
    if (this.viajeSeleccionado) {
      this.modalService.show(ModalCancelarViajeComponent, {
        ignoreBackdropClick: false,
        keyboard: true,
        class: 'modal-dialog-centered modal-xs',
        initialState: {
          viaje: this.viajeSeleccionado
        }
      });
    }
  }

  // Verifica si el viaje ya ha sido iniciado
  viajeIniciado(): boolean {
    return this.viajeSeleccionado?.estado === 'INICIADO' || this.viajeSeleccionado?.estado === 'EN_CURSO';
  }

  // CON-1004: no se permite editar ningún campo si el viaje está NO_INICIADO o FINALIZADO
  edicionBloqueada(): boolean {
    return this.viajeSeleccionado?.estado === 'NO_INICIADO' || this.viajeSeleccionado?.estado === 'FINALIZADO';
  }

  getTooltipConfirmarImprimir(): string | null {
    if (this.edicionBloqueada()) return 'No se puede editar un viaje no iniciado o finalizado';
    if (!this.puedeConfirmar()) return 'Debes asignar bus y conductor al viaje';
    return null;
  }

  // Verifica si el botón confirmar debe estar habilitado
  puedeConfirmar(): boolean {
    if (!this.viajeSeleccionado || this.viajeSeleccionado.confirmado) {
      return false;
    }

    return this.viajeSeleccionado.movil !== null && this.viajeSeleccionado.conductor !== null;
  }

  // Verifica si el botón asignar bus debe estar habilitado
  puedeAsignarMovil(): boolean {
    if (!this.movilSeleccionado || !this.viajeSeleccionado) {
      return false;
    }

    // Si no hay bus asignado previamente, permitir asignación
    if (!this.viajeSeleccionado.movil) {
      return true;
    }

    // Si hay bus asignado, solo permitir si es diferente al seleccionado
    return this.movilSeleccionado.uuid !== this.viajeSeleccionado.movil.uuid;
  }

  get mensajeNoPuedeAsignarMovil() {
    if (this.edicionBloqueada()) {
      return 'No se puede editar un viaje no iniciado';
    }
    if (this.viajeSeleccionado && this.viajeSeleccionado.movil) {
      return 'El viaje ya tiene un bus asignado';
    }
    return 'Debe seleccionar un bus de la lista'
  }

  get mensajeNoPuedeAsignarConductor() {
    if (this.edicionBloqueada()) {
      return 'No se puede editar un viaje no iniciado';
    }
    if (this.viajeSeleccionado && this.viajeSeleccionado.conductor) {
      return 'El viaje ya tiene un conductor asignado';
    }
    return 'Debe seleccionar un conductor de la lista'
  }

  // Verifica si el botón asignar conductor debe estar habilitado
  puedeAsignarConductor(): boolean {
    if (!this.conductorSeleccionado || !this.viajeSeleccionado) {
      return false;
    }

    // Si no hay conductor asignado previamente, permitir asignación
    if (!this.viajeSeleccionado.conductor) {
      return true;
    }

    // Si hay conductor asignado, solo permitir si es diferente al seleccionado
    return this.conductorSeleccionado.uuid !== this.viajeSeleccionado.conductor.uuid;
  }

  sumarCincoMinutos() {
    if (!this.inicioEditado) return;
    this.inicioEditado = this.inicioEditado.clone().add(5, 'minutes');
    this.aplicarDesplazamientoParaderos();
  }

  restarCincoMinutos() {
    if (!this.inicioEditado) return;
    this.inicioEditado = this.inicioEditado.clone().subtract(5, 'minutes');
    this.aplicarDesplazamientoParaderos();
  }

  // CON-1004: desplaza en vivo TODOS los paraderos según el delta del inicio editado vs el original,
  // sin esperar al backend. El día corre solo al cruzar medianoche (lo maneja el moment de inicioEditado).
  aplicarDesplazamientoParaderos() {
    this.fechaPrimeraParada = this.inicioEditado.format('HH:mm');
    if (!this.paradasOriginales.length) return;
    const inicioOriginal = moment.utc(this.paradasOriginales[0]).local();
    const deltaMinutos = this.inicioEditado.diff(inicioOriginal, 'minutes');
    this.paradas.forEach((parada, i) => {
      parada.fechahoraPlanificada = moment.utc(this.paradasOriginales[i]).local().add(deltaMinutos, 'minutes').toISOString();
    });
  }

  get getInicioModif() {

    if (!this.viajeSeleccionado ||
      !this.viajeSeleccionado.fechahoraInicioOriginalPlanificado ||
      !this.viajeSeleccionado.fechahoraInicio
    ) {
      return "--";
    }

    if (this.viajeSeleccionado.fechahoraInicioOriginalPlanificado !==
      this.viajeSeleccionado.fechahoraInicio
    ) {
      const value = moment.utc(this.viajeSeleccionado.fechahoraInicioOriginalPlanificado).local()
      const hhmm = value.format('hh:mm');
      return hhmm;
    }

    return "--";

  }

  guardarHoraInicio(): void {

    if (this.viajeSeleccionado && this.paradas.length > 0 && !this.viajeIniciado() && !this.edicionBloqueada() && this.inicioEditado) {
      // CON-1004: el inicio editado ya tiene el día correcto (los +/- cruzan medianoche)
      const horaModificada = this.inicioEditado.clone().set({ second: 0, millisecond: 0 }).toISOString();

      // CON-1004: la nueva fecha y hora de inicio no puede ser anterior a la fecha y hora actual
      if (moment(horaModificada).isBefore(moment())) {
        this.toastr.warning('La hora de inicio no puede ser anterior a la fecha y hora actual');
        return;
      }

      this.guardandoHora = true;
      this.apiService.putEditarInicioViaje(this.viajeSeleccionado.uuid, horaModificada).subscribe(
        (resp) => this.editarHoraInicioViajeSuccess(resp),
        (error) => this.editarHoraInicioViajeError(error)
      );
    }
  }

  editarHoraInicioViajeSuccess(resp: GeneralResponseDTO) {
    this.guardandoHora = false;
    this.toastr.success(resp.msg, '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false })
    this.cargarParadas();
  }

  editarHoraInicioViajeError(error: HttpErrorResponse) {
    console.log('error editar hora inicio', error);
    this.guardandoHora = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_EDITAR_HORA_INICIO_DESPACHADOR_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  // Bus search methods
  onBusSearchChange(text: string): void {
    this.busSearchSubject.next(text);
    this.showBusResults = true;
  }

  getListaConductores(): void {
    this.conductorLoading = true;
    // Get the sucursalUuid from the first parada's paradero
    const sucursalUuid = this.viajeSeleccionado.sucursalOrigen.uuid;


    this.apiService.getListaConductores(
      0, // page
      1000, // pageSize
      sucursalUuid,
      '',
      'visibleId',
      true, // orderAsc
      false,
      'DISPONIBLE',
      this.tipoBusqueda
    ).subscribe(
      (resp) => this.getListaConductoresSuccess(resp),
      (error) => this.getListaConductoresError(error)
    );
  }

  getListaConductoresSuccess(resp: GetListaConductoresResponseDTO) {
    this.listaConductores = resp.data.list;
    this.conductorLoading = false;
  }

  getListaConductoresError(error: HttpErrorResponse) {
    this.conductorLoading = false;
  }

  getListaMoviles() {
    const sucursalUuid = this.viajeSeleccionado.sucursalOrigen.uuid;
    this.apiService.getListaMovilesDisponibles(
      0, // page
      1000, // pageSize
      '',
      sucursalUuid,
      'numeroInterno',
      true, // orderAsc
      'DISPONIBLE,EN_LAVADO,EN_CARGA',
      this.tipoBusqueda
    ).subscribe(
      (resp) => this.getListaMovilesSuccess(resp),
      (error) => this.getListaMovilesError(error)
    );
  }

  getListaMovilesSuccess(resp: GetListaMovilesResponseDTO) {
    this.listaMoviles = resp.data.list;
  }

  getListaMovilesError(error: HttpErrorResponse) {

  }

  asignarMovil(): void {

    if (!this.movilSeleccionado || !this.viajeSeleccionado) {
      return;
    }

    // CON-1004: no permitir asignar si el viaje está NO_INICIADO o FINALIZADO
    if (this.edicionBloqueada()) {
      return;
    }

    // Validar que el móvil esté disponible
    if (this.movilSeleccionado.estado !== 'DISPONIBLE') {
      this.toastr.warning('No se puede asignar un bus que no esté disponible', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    this.asignandoMovil = true;
    this.apiService.putCambiarBus(this.viajeSeleccionado.uuid, this.movilSeleccionado.uuid)
      .pipe(
        finalize(() => {
          this.asignandoMovil = false;
          this.getListaMoviles();
        })
      )
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.toastr.success(response.msg, '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
            this.viajeSeleccionado.movil = this.movilSeleccionado;
            //CON-1057: cambiar el bus anula la confirmacion en servicios, asi que el viaje vuelve a
            //pedir "Confirmar & Imprimir" y deja de ofrecer la reimpresion del vale
            this.viajeSeleccionado.confirmado = false;
            this.viajeService.setViajeSeleccionado(this.viajeSeleccionado);
            this.eventService.publish('ASIGNACION_VIAJE_EVENT');
          } else {
            this.toastr.warning(response.msg || 'Error al asignar el bus', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
          }
        },
        error: (error) => {
          console.log('error asignar movil', error);
          const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_ASIGNAR_MOVIL_DESPACHADOR_WS;
          // Si el bus ya fue asignado a otro viaje (conflicto), limpiar la selección
          if (error.status === 409) {
            this.movilSeleccionado = null;
          }
          this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      });
  }

  asignarConductor(): void {

    if (!this.conductorSeleccionado || !this.viajeSeleccionado) {
      return;
    }

    // CON-1004: no permitir asignar si el viaje está NO_INICIADO o FINALIZADO
    if (this.edicionBloqueada()) {
      return;
    }

    this.asignandoConductor = true;
    this.apiService.putCambiarConductor(this.viajeSeleccionado.uuid, this.conductorSeleccionado.uuid)
      .pipe(
        finalize(() => {
          this.asignandoConductor = false;
          this.getListaConductores();
        })
      )
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.toastr.success(response.msg, '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
            this.viajeSeleccionado.conductor = this.conductorSeleccionado;
            //CON-1057: cambiar el conductor anula la confirmacion en servicios, asi que el viaje
            //vuelve a pedir "Confirmar & Imprimir" y deja de ofrecer la reimpresion del vale
            this.viajeSeleccionado.confirmado = false;
            this.viajeService.setViajeSeleccionado(this.viajeSeleccionado);
            this.eventService.publish('ASIGNACION_VIAJE_EVENT');
          } else {
            this.toastr.warning(response.msg || 'Error al asignar el conductor', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
          }
        },
        error: (error) => {
          console.log('error asignar conductor', error);
          const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_ASIGNAR_CONDUCTOR_DESPACHADOR_WS;
          // Si el conductor ya fue asignado a otro viaje (conflicto), limpiar la selección
          if (error.status === 409) {
            this.conductorSeleccionado = null;
          }
          this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      });
  }

  quitarMovil(): void {

    if (!this.viajeSeleccionado) {
      return;
    }

    this.quitandoMovil = true;
    this.apiService.putQuitarBus(this.viajeSeleccionado.uuid)
      .pipe(
        finalize(() => {
          this.quitandoMovil = false
          this.getListaMoviles();
        })
      )
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.toastr.success(response.msg, '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
            this.viajeSeleccionado.movil = null;
            this.eventService.publish('ASIGNACION_VIAJE_EVENT');
          } else {
            this.toastr.warning(response.msg || 'Error al remover el bus', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
          }
        },
        error: (error) => {
          console.log('error eliminar movil', error);
          const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_ELIMINAR_MOVIL_DESPACHADOR_WS;
          this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      });
  }

  quitarConductor(): void {

    if (!this.viajeSeleccionado) {
      return;
    }

    this.quitandoConductor = true;
    this.apiService.putQuitarConductor(this.viajeSeleccionado.uuid)
      .pipe(
        finalize(() => {
          this.getListaConductores();
          this.quitandoConductor = false;
        })
      )
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.toastr.success(response.msg, '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
            this.viajeSeleccionado.conductor = null;
            this.eventService.publish('ASIGNACION_VIAJE_EVENT');
          } else {
            this.toastr.warning(response.msg || AppMessage.ERROR_PUT_ELIMINAR_CONDUCTOR_DESPACHADOR_WS, 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
          }
        },
        error: (error) => {
          console.log('error eliminar conductor', error);
          const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_ELIMINAR_CONDUCTOR_DESPACHADOR_WS;
          this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      });
  }

  // Conductor search methods
  onConductorSearchChange(text: string): void {
    this.conductorSearchSubject.next(text);
    this.showConductorResults = true;
  }

  searchConductores(searchText: string): void {
    if (!searchText || searchText.trim().length < 2) {
      this.conductorSearchResults = [];
      return;
    }

    this.conductorLoading = true;
    // Get the sucursalUuid from the first parada's paradero
    const sucursalUuid = this.paradas.length > 0 ? this.paradas[0]?.paradero?.uuid || '' : '';

    this.apiService.getListaConductores(
      0, // page
      100, // pageSize
      sucursalUuid,
      searchText,
      'visibleId',
      true, // orderAsc
      false,
      'DISPONIBLE'
    ).subscribe({
      next: (response) => {
        this.conductorSearchResults = response.data.list;
        this.conductorLoading = false;
      },
      error: (error) => {
        console.error('Error searching conductores:', error);
        this.conductorLoading = false;
        this.conductorSearchResults = [];
        this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
      }
    });
  }

  /*
  selectConductor(conductor: ConductorDTO): void {
    this.selectedConductor = conductor;
    this.conductorSearchText = conductor.visibleId || '';
    this.showConductorResults = false;
    this.conductorService.setConductorSeleccionado(conductor);
    // Update assignment status based on selection
    if (this.viajeSeleccionado?.conductor) {
      // If selecting the same conductor that's already assigned, keep it as assigned
      this.conductorAsignado = conductor.uuid === this.viajeSeleccionado.conductor.uuid;
    } else {
      // If no conductor was assigned, reset assignment status
      this.conductorAsignado = false;
    }
  }
  */

  /**
 * Muestra las horas disponibles respecto a la jornada de trabajo y horas trabajadas
 */
  getHorasDisponibles(conductor: ConductorDTO): string {
    if (!conductor || !conductor.jornadaEnCurso) {
      return '--';
    }
    return this.convertirMinutosAHHMM(conductor.jornadaEnCurso.minutosRestantes);
  }

  convertirMinutosAHHMM(minutos: number): string {
    const horas = Math.floor(minutos / 60);
    const mins = minutos % 60;
    return `${horas.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }

  // Helper method to format minutes as hours and minutes
  formatMinutesToHoursAndMinutes(minutes: number | string | undefined): string {
    if (!minutes) {
      return '--'; // No hardcoded value, just indicate no data
    }

    // Convert to number if it's a string
    const mins = typeof minutes === 'string' ? parseInt(minutes, 10) : minutes;

    // Check if it's a valid number
    if (isNaN(mins)) {
      return '--'; // No hardcoded value, just indicate no data
    }

    const hours = Math.floor(mins / 60);
    const remainingMins = mins % 60;
    return `${hours}h ${remainingMins}m`;
  }

  hayConductorAsignado() {
    return this.viajeSeleccionado.conductor;
  }

  hayMovilAsignado() {
    return this.viajeSeleccionado.movil;
  }

  getRutaViajePDF() {
    this.procesandoPdf = true;
    this.apiService.getRutaViajePDF(this.viajeSeleccionado.uuid)
      .subscribe((resp) => this.getRutaViajePDFSuccess(resp), (error) => this.getRutaViajePDFError(error));
  }

  getRutaViajePDFSuccess(pdfDTO: PdfDTO) {
    this.procesandoPdf = false;
    if (pdfDTO.base64Content)
      pdfDTO.generatePdfFromBase64();
    else
      this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
  }

  getRutaViajePDFError(error: HttpErrorResponse) {
    this.procesandoPdf = false;
    console.log('error kpis', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  // Interceptor para prevenir selección de móviles no disponibles
  onMovilSelectionChange(selectedMovil: MovilDTO): void {
    if (selectedMovil && selectedMovil.estado !== 'DISPONIBLE') {
      this.toastr.warning('No se puede seleccionar un bus que no esté disponible', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      // Resetear la selección
      this.movilSeleccionado = null;
    }
  }

  // Interceptor para prevenir selección de conductores no disponibles
  onConductorSelectionChange(selectedConductor: ConductorDTO): void {
    if (selectedConductor && selectedConductor.estado !== 'DISPONIBLE') {
      this.toastr.warning('No se puede seleccionar un conductor que no esté disponible', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      // Resetear la selección
      this.conductorSeleccionado = null;
    }
  }

  muestraDiferenciaHorasMinutosParadero(fechaPlanificada: string, fechaReal: string) {
    if(!fechaPlanificada || !fechaReal)
      return '';

    const fecha2 = moment.utc(fechaPlanificada);
    const fecha1 = moment.utc(fechaReal);
    if(fecha2 >= fecha1)
      return fecha1.diff(fecha2, 'minutes') + 'm';
    else
      return '+' + fecha1.diff(fecha2, 'minutes') + 'm';
  }

}
